export default __webpack_public_path__ + "static/media/696.647fb4b3.gif";